/* eslint-disable default-case */
import 'react-toastify/dist/ReactToastify.css';

import { toast } from 'react-toastify';

import { getUserProperty } from '../../../../util/helper';
import { MESSAGES } from '../../../../constants/messages';
import {
  MAX_ITENS_POR_PROTOCOLO,
  PROTOCOLO_ERROS_MENSAGENS,
} from '../../../../constants/protocolo';
import * as storage from '../../../../services/storage';
import EnvioTypes from './types';
import * as trackTime from '../../../../services/tracking-time';

const INITIAL_STATE = {
  contratos: [],
  incluidos: [],
  protocolo_tipo: null,
  numero_envelope: null,
  resetProtocolo: false,
  alertMessage: '',
  filter_fields: [],
  select_produtos: [],
  select_produtos_original: [],
  select_lojas: [],
  select_promotoras: [],
  select_convenios: [],
  loadingSelects: false,
  protocoloFinalizadoNumero: '',
  redirectImpressao: false,
  user: {},
  error: false,
  loading: false,
  selecionarTodos: false,
  protocolo_massa_erros: [],
  nome_sistema: '',
};

const dossieParse = (oldItem, state) => {
  const item = { ...oldItem };

  item.disable = false;
  item.message = '';

  switch (state.protocolo_tipo) {
    case 'protocolo_principal':
      if (item.TipoSituacao !== 'NAOPROTOCOLADO') {
        item.disable = true;
        item.message = 'Contrato já protocolado';
      }
      break;
    case 'protocolo_complemento':
      if (item.TipoSituacao === 'NAOPROTOCOLADO') {
        item.disable = true;
        item.message = 'Contrato não possui protocolo principal';
      }
      break;
  }

  return item;
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case EnvioTypes.CLEAR:
      return { ...state, contratos: [] };

    case EnvioTypes.CLEARINCL:
      return {
        ...state,
        incluidos: [],
        resetProtocolo: false,
        redirectImpressao: false,
      };

    case EnvioTypes.SEARCH_REQUEST:
      return {
        ...state,
        protocolo_tipo: action.param.tipo,
        filter_fields: action.param.filter_fields,
        loading: true,
        selecionarTodos: false,
      };

    case EnvioTypes.SEARCH_FAILURE:
      toast.error(MESSAGES.DEFAULT_ERROR_MESSAGE);
      return { ...state, loading: false, error: true };

    case EnvioTypes.SEARCH_SUCCESS:
      /* Verifica o status dos contratos para desabilitar a seleção */
      const cont = action.payload.map((item) => dossieParse(item, state));

      if (!cont.length) {
        toast.error(MESSAGES.EMPTY_ERROR_MESSAGE);
      }

      return {
        ...state,
        contratos: cont,
        loading: false,
        error: false,
      };

    case EnvioTypes.SAVE_REQUEST:

      return {
        ...state,
        protocolo_tipo: action.payload.tipo,
        numero_envelope: action.payload.numero_envelope,
        user: action.payload.dados_usuario
          ? action.payload.dados_usuario.user
          : 'Admin',
        loading: false,
        error: false,
      };

    case EnvioTypes.SAVE_SUCCESS:
      return {
        ...state,
        protocoloFinalizadoNumero: action.payload.numero_protocolo,
        resetProtocolo: true,
        alertMessage: action.payload.message,
      };

    case EnvioTypes.SEARCH_PROTOCOLO_REQUEST:
      return {
        ...state,
        loading: false,
        error: false,
      };

    case EnvioTypes.SEARCH_PROTOCOLO_SUCCESS:
      return {
        ...state,
        redirectImpressao: !!action.payload[0],
      };

    case EnvioTypes.SELECTS_REQUEST:
      return {
        ...state,
        protocolo_tipo: action.payload.tipo,
        loading: false,
        error: false,
        loadingSelects: true,
      };

    case EnvioTypes.SELECTS_SUCCESS:
      return {
        ...state,
        select_produtos:
          !!action.payload.produtos && action.payload.produtos.length
            ? action.payload.produtos
            : [],
        select_produtos_original:
          !!action.payload.produtos && action.payload.produtos.length
            ? action.payload.produtos
            : [],
        select_lojas:
          action.payload.lojas.length > 0 ? action.payload.lojas : [],
        select_promotoras:
          action.payload.promotoras.length > 0
            ? action.payload.promotoras
            : [],
        select_convenios:
          action.payload.convenios.length > 0
            ? action.payload.convenios
            : [],
        alertMessage: action.payload.message,
        loadingSelects: false,
      };

    case EnvioTypes.REQUEST_FAILURE:
      toast.error(
        action.payload
          ? action.payload.data.erro
          : MESSAGES.DEFAULT_ERROR_MESSAGE,
      );
      return {
        ...state,
        loading: false,
        error: true,
        loadingSelects: false,
      };

    case EnvioTypes.SELECT:
      const contratos_select = state.contratos.map((contrato) => (contrato._id === action.payload.id && !contrato.disable
        ? {
          ...contrato,
          isSelected: !contrato.isSelected,
        }
        : contrato));
      const contratosDisponiveis = contratos_select.filter(
        (contrato) => action.payload.visibleIds.some(
          (id) => id === contrato._id,
        ) && !contrato.disable,
      );
      return {
        ...state,
        contratos: contratos_select,
        selecionarTodos:
          !!contratosDisponiveis.length
          && contratosDisponiveis.every(
            (contrato) => !!contrato.isSelected,
          ),
      };

    case EnvioTypes.CLEAR_SELECT:
      const contratos = state.contratos.map((contrato) => ({
        ...contrato,
        isSelected: false,
      }));
      return {
        ...state,
        contratos,
        selecionarTodos: false,
      };

    case EnvioTypes.SELECT_MULTI:
      const contratos_select_multi = state.contratos.map((contrato) => ({
        ...contrato,
        isSelected:
          action.payload.checked
          && action.payload.ids.some((id) => id === contrato._id)
          && !contrato.disable,
      }));

      const contratosDisponiveisSelectAll = contratos_select_multi.filter(
        (contrato) => action.payload.ids.some((id) => id === contrato._id)
          && !contrato.disable,
      );

      return {
        ...state,
        contratos: contratos_select_multi,
        selecionarTodos:
          !!contratosDisponiveisSelectAll.length
          && contratosDisponiveisSelectAll.every(
            (contrato) => !!contrato.isSelected,
          ),
      };

    case EnvioTypes.INCLUDE:
      var ids = new Set(state.incluidos.map((d) => d.IdContrato));
      var incluidos = [...state.incluidos];

      if (state.incluidos.length >= action.MAX_ITENS_POR_PROTOCOLO) {
        toast.error(PROTOCOLO_ERROS_MENSAGENS.LIMITE_MAX_PROTOCOLO);
      }

      const novosFiltrados = action.selecionados.filter(
        (d) => !ids.has(d.IdContrato),
      );
      novosFiltrados.splice(
        action.MAX_ITENS_POR_PROTOCOLO - incluidos.length,
        novosFiltrados.length,
      );
      incluidos = [...state.incluidos, ...novosFiltrados];

      var removeSelect = state.contratos.map((item) => ({
        ...item,
        isSelected: false,
      }));

      return {
        ...state,
        incluidos,
        contratos: removeSelect,
        selecionarTodos: false,
      };

    case EnvioTypes.FORCE_INCLUDE:
      const novos_force = state.contratos.filter(
        (contrato) => contrato.isSelected,
      );

      const ids_force = new Set(state.incluidos.map((item) => item._id));

      let incluidos_force = state.incluidos;
      let removeSelect_force = state.contratos;

      if (
        incluidos_force.length + novos_force.length
        <= MAX_ITENS_POR_PROTOCOLO
      ) {
        incluidos_force = [
          ...state.incluidos,
          ...novos_force.filter((item) => !ids_force.has(item._id)),
        ];

        removeSelect_force = state.contratos.map((item) => ({
          ...item,
          isSelected: false,
        }));
      } else {
        toast.error(
          `Limite máximo de contratos por protocolo é ${
            MAX_ITENS_POR_PROTOCOLO}`,
        );
      }

      return {
        ...state,
        incluidos,
        contratos: removeSelect_force,
      };

    case EnvioTypes.FORCE_INCLUDE_DOCUMENTOS:
      const contratos_force_doc = state.contratos.map((contrato) => ({
        ...contrato,
        isSelected: action.payload.contrato === contrato._id,
        documentos_devolucao:
          action.payload.contrato === contrato._id
            ? action.payload.documentos_devolucao
            : contrato.documentos_devolucao,
      }));

      return {
        ...state,
        contratos: contratos_force_doc,
      };

    case EnvioTypes.PROTOCOLO_MASSA_VALIDAR_REQUEST:
      return {
        ...state,
        protocolo_tipo: action.payload.type,
        lista_protocolo_massa: action.payload.params.numeros_dossies,
        protocolo_massa_erros: [],
        nome_sistema: action.payload.nomeSistema,
      };

    case EnvioTypes.PROTOCOLO_MASSA_CLOSE:
      return {
        ...state,
        protocolo_massa_erros: [],
      };
    case EnvioTypes.PROTOCOLO_MASSA_VALIDAR_FAUILURE:
      toast.error(PROTOCOLO_ERROS_MENSAGENS.ERRO_PROTOCOLO_MASSA);
      return {
        ...state,
        protocolo_massa_erros: [],
      };

    case EnvioTypes.PROTOCOLO_MASSA_VALIDAR_SUCCESS:

      // eslint-disable-next-line no-case-declarations
      let included = [...state.incluidos];

      // eslint-disable-next-line no-case-declarations
      const listaContratos = {
        valid: [],
        invalid: [],
      };
      const { current_idaplicacao: idaplicacao } = getUserProperty();

      const validateFunction = idaplicacao === 'E42EEFB0-FF92-4C59-BB0D-B8E41CFBDF5A'
        ? (obj, dossie) => obj.NumeroContrato === dossie
        : (obj, dossie) => obj.CPFCNPJ === dossie;

      for (const dadoPesquisado of state.lista_protocolo_massa) {
        const validDossie = action.payload.find((dossieData) => validateFunction(dossieData, dadoPesquisado));

        if (!validDossie) {
          listaContratos.invalid.push({
            disabled: true,
            NumeroContrato: dadoPesquisado,
            message: 'Contrato não encontrado',
          });
        }
      }
      let constratosIncluidos = storage.getItem(
        `contratosAdicionados-${state.protocolo_tipo}-${state.nome_sistema}`,
      );
      constratosIncluidos = constratosIncluidos
        ? [...constratosIncluidos, ...action.payload].reduce((acum, contrato) => {
          if (!acum.some((c) => c.IdContrato === contrato.IdContrato)) acum.push(contrato);
          return acum;
        }, [])
        : action.payload;

      for (const contrato of action.payload) {
        const contratoAvaliado = {
          ...dossieParse(contrato, state),
          isSelected: true,
        };

        if (contratoAvaliado.disable) {
          listaContratos.invalid.push(contratoAvaliado);
        } else {
          listaContratos.valid.push(contratoAvaliado);
        }
      }

      if (included.length + listaContratos.valid.length > MAX_ITENS_POR_PROTOCOLO) {
        toast.error(PROTOCOLO_ERROS_MENSAGENS.LIMITE_MAX_PROTOCOLO);
        const contratosExcedentes = listaContratos.valid.splice(MAX_ITENS_POR_PROTOCOLO - included.length);
        listaContratos.invalid = contratosExcedentes.map(({ NumeroContrato }) => ({
          NumeroContrato,
          message: `Excedida a quantidade máxima de ${MAX_ITENS_POR_PROTOCOLO} contratos por protocolo.`,
        }));
      }

      included = [...included, ...listaContratos.valid].reduce((acum, contrato) => {
        if (!acum.some((c) => c.IdContrato === contrato.IdContrato)) acum.push(contrato);

        return acum;
      }, []);

      if (!state.incluidos.length && !!included.length) {
        trackTime.start(state.protocolo_tipo);
      }

      storage.setItem(
        `contratosAdicionados-${state.protocolo_tipo}-${state.nome_sistema}`,
        included,
      );

      return {
        ...state,
        incluidos: included,
        protocolo_massa_erros: listaContratos.invalid,
      };

    case EnvioTypes.REMOVE:
      const IncluidosAtualizado = state.incluidos.filter(
        (c) => c.IdContrato !== action.payload.id,
      );

      return {
        ...state,
        incluidos: IncluidosAtualizado,
      };

    case EnvioTypes.LISTA_PROMOTORAS_SUCCESS:
      return {
        ...state,
        select_promotoras:
          !!action.payload && action.payload.length
            ? action.payload
            : [],
        alertMessage: action.payload.message,
      };

    case EnvioTypes.LISTA_LOJAS_SUCCESS:
      return {
        ...state,
        select_lojas:
          !!action.payload && action.payload.length
            ? action.payload
            : [],
        alertMessage: action.payload.message,
      };

    case EnvioTypes.LISTA_CONVENIOS_SUCCESS:
      return {
        ...state,
        select_convenios:
          !!action.payload && action.payload.length
            ? action.payload
            : [],
        alertMessage: action.payload.message,
      };

    case EnvioTypes.LISTA_PRODUTOS_SUCCESS:
      return {
        ...state,
        select_produtos:
          !!action.payload && action.payload.length
            ? action.payload
            : [],
        select_produtos_original:
          !!action.payload && action.payload.length
            ? action.payload
            : [],
        alertMessage: action.payload.message,
      };

    case EnvioTypes.FILTER_PRODUTOS_POR_CONVENIO:
      const novosProdutos = !action.payload
        ? state.select_produtos_original
        : state.select_produtos_original.filter(({ value }) => action.payload.some(({ codigo }) => codigo === value));
      return {
        ...state,
        select_produtos: novosProdutos,
      };

    default:
      return state;
  }
};
